function PermissionMenu({ children, isPermission }) {
  if (!isPermission) {
    return null;
  }
  return children;
}

export default PermissionMenu;
